/** Chemins UI relevés entreprise (distincts des factures prestataires). */

export function companyBillingDetailPath(statementId: number | string): string {
  return `/dashboard/billing/${statementId}`;
}

export function companyBillingListPath(status?: "approved"): string {
  if (status === "approved") {
    return "/dashboard/invoices/approved";
  }
  return "/dashboard/invoices";
}
